import { IntlContextValue, useIntl } from "~frontend/providers/IntlProvider";

export type Contact = {
  firstName?: string | null;
  lastName?: string | null;
};

export default function formatContactName(
  contact: Contact,
  {
    overrideNoNameText,
    formatMessage,
  }: {
    overrideNoNameText?: string;
    formatMessage: IntlContextValue["formatMessage"];
  }
): string {
  const { firstName, lastName } = contact;

  // John Doe
  if (firstName && lastName) {
    return `${firstName} ${lastName}`;
  }

  // John
  if (firstName) {
    return firstName;
  }

  // (no first name) Doe
  if (lastName) {
    return formatMessage(
      {
        defaultMessage: `(no first name) {lastName}`,
        description:
          "Contact name where there is a last name available but no first name",
      },
      { lastName }
    );
  }

  // (no name)
  if (overrideNoNameText) {
    return overrideNoNameText;
  }
  return formatMessage({
    defaultMessage: "(no name)",
    description: "Display name for contacts with no name",
  });
}

export function useContactNameFormatter(): (
  contact: Contact,
  opts?: {
    overrideNoNameText?: string;
  }
) => string {
  const { formatMessage } = useIntl();
  return (contact, opts) =>
    formatContactName(contact, { ...opts, formatMessage });
}
